import { ACTIVE_STATUS, ORDER_PRODUCT_STATUS } from "@/constants";
import { checkPricingUtilIsValidPrice } from "@/services/utils";

/**
 * Decides whether the "Requested Housing" column reads the order room's requested_room
 * or falls back to the order room itself.
 *
 * While the item is unfulfilled the requested room follows the order room, so the order
 * room is always the live answer. Fulfilling freezes requested_room at the room the
 * student asked for, and canceling leaves it as it was, so from then on it is the one to
 * show - unless nothing was ever recorded on it.
 */
export const usesRequestedRoom = (orderRoom) =>
  orderRoom?.status !== ORDER_PRODUCT_STATUS.unfulfilled && !!orderRoom?.requested_room?.id;

/**
 * The room the "Requested Housing" column is showing, for the places that need a field off
 * it rather than the decision itself - the room-type dropdown's selection and its label.
 */
export const getDisplayedRoom = (orderRoom) =>
  usesRequestedRoom(orderRoom) ? orderRoom?.requested_room : orderRoom?.room;

export const checkValidRequestedRoom = (room, startDate) =>
  room?.status === ACTIVE_STATUS &&
  !!room?.product_prices?.some((price) =>
    checkPricingUtilIsValidPrice(price.effective_start_date, price.effective_end_date, startDate),
  );
